import { PortableText } from '@portabletext/react'
import {
  type ArbitraryTypedObject,
  type PortableTextBlock,
} from '@portabletext/types'

import ColoredText from './portable-text/colored-text'
import Link from './portable-text/link'

type SimplePortableTextBlock = PortableTextBlock | ArbitraryTypedObject

interface SimplePortableTextProps {
  content: SimplePortableTextBlock[]
  className?: string
}

const SimplePortableText = ({
  content,
  className,
}: SimplePortableTextProps) => {
  return (
    <div className={className}>
      <PortableText
        value={content}
        components={{
          block: {
            none: ({ children }) => <>{children}</>,
            normal: ({ children }) => <p>{children}</p>,
          },
          marks: {
            link: Link,
            textColor: ColoredText,
          },
        }}
      />
    </div>
  )
}

export default SimplePortableText
